import {axiosInstance} from './axios';

export async function getUsersApi() {
  try {
    return await axiosInstance.get('/api/v1/admins');
  } catch (e) {
    return null;
  }
}

export async function addUser(data) {
  try {
    return await axiosInstance.post('/api/v1/admins', data);
  } catch (e) {
    return null;
  }
}

export async function getUserApi(id) {
  try {
    return await axiosInstance.get(`/api/v1/admins/${id}`);
  } catch (e) {
    return null;
  }
}

export async function editUserApi(data, id) {
  try {
    return await axiosInstance.put(`/api/v1/admins/${id}`, data);
  } catch (e) {
    return null;
  }
}

export async function removeUserApi(id) {
  try {
    return await axiosInstance.delete(`/api/v1/admins/${id}`);
  } catch (e) {
    return null;
  }
}
